import React from 'react'
import { Edit3, Music } from 'lucide-react'
import { cn } from '../lib/utils'

const StudioModeToggle = ({ isActive, onToggle, disabled = false }) => {
  return (
    <div className="flex items-center gap-3">
      {/* Animated Toggle Switch */}
      <button
        onClick={onToggle}
        disabled={disabled}
        className={cn(
          'relative flex items-center rounded-full p-1 transition-all duration-300 ease-in-out',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent',
          'disabled:cursor-not-allowed disabled:opacity-40',
          'w-[280px] h-14',
          isActive
            ? 'bg-blue-600 hover:bg-blue-700 shadow-lg'
            : 'bg-white/20 hover:bg-white/30 backdrop-blur-sm'
        )}
      >
        {/* Sliding Indicator */}
        <div
          className={cn(
            'absolute top-1 bottom-1 w-[calc(50%-4px)] rounded-full transition-all duration-300 ease-in-out',
            'bg-white shadow-lg',
            isActive ? 'left-[calc(50%+2px)]' : 'left-1'
          )}
        />

        {/* Labels */}
        <div className="relative z-10 flex w-full h-full">
          {/* Practice Mode Label */}
          <div
            className={cn(
              'flex-1 flex items-center justify-center gap-2 transition-all duration-300',
              !isActive ? 'text-blue-600 font-semibold' : 'text-white/60 font-medium'
            )}
          >
            <Music className="w-5 h-5" />
            <span>Practice</span>
          </div>

          {/* Studio Mode Label */}
          <div
            className={cn(
              'flex-1 flex items-center justify-center gap-2 transition-all duration-300',
              isActive ? 'text-blue-600 font-semibold' : 'text-white/60 font-medium'
            )}
          >
            <Edit3 className="w-5 h-5" />
            <span>Studio</span>
          </div>
        </div>
      </button>

      {/* Editing Indicator */}
      {isActive && (
        <div className="flex items-center gap-2 px-3 py-1 rounded-full bg-orange-500/20 text-orange-300 text-sm backdrop-blur-sm animate-in fade-in duration-200">
          <div className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
          <span className="font-medium">Editing</span>
        </div>
      )}
    </div>
  )
}

export default StudioModeToggle
